import type { TableFilterItem } from '../types';

/**
 * Calculate filter counter badge value
 *
 * Shows counter if:
 * 1. Some items are applied (> 0)
 * 2. AND either:
 *    a) Not all items are applied (< total), OR
 *    b) showAlways flag is true (e.g., for SPOT filter)
 *
 * @param filterItems - All available filter items
 * @param appliedValues - Currently applied filter values
 * @param showAlways - Force show counter even if all items selected (for SPOT)
 * @returns Counter value or undefined (undefined = don't show badge)
 */
export const calculateFilterCount = (filterItems: TableFilterItem[], appliedValues: string[], showAlways = false): number | undefined => {
  const availableIds = filterItems.map((item) => item.id);
  const count = appliedValues.filter((value) => availableIds.includes(value)).length;

  // Show counter if some items applied AND (not all selected OR showAlways)
  const shouldShow = count > 0 && (count < availableIds.length || showAlways);

  return shouldShow ? count : undefined;
};
